import React, { Component } from 'react';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Grid from '@mui/material/Grid';
import './Dashboard.css';
export default class google extends Component {
  state = {
    data: [[]],
  }

  dataFormatter = (data) => {
    let tmp = [];
    for (let i = 0; i < data.length; i++) {
      let t = [];
      t.push(((data[i].date)));
      t.push(parseInt((data[i].temperature), 0))
      tmp.push(t)
    }
    return tmp;
  }

  render() {

    let config = {
      chart: {
        zoomType: 'x',
        height: 100,
        width: 1000,
      },
      title: {
        text: ''
      },
      xAxis: {
        type: 'datetime',
        labels: {
          enabled: false,
        },
      },
      yAxis: {
        title: {
          text: ''
        }
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        area: {
          fillColor: {
            linearGradient: {
              x1: 0,
              y1: 0,
              x2: 0,
              y2: 1
            },
            stops: [
              [0, Highcharts.getOptions().colors[0]],
              [1, Highcharts.color(Highcharts.getOptions().colors[0]).setOpacity(0).get('rgba')]
            ]
          },
          marker: {
            radius: 2
          },
          lineWidth: 1,
          states: {
            hover: {
              lineWidth: 1
            }
          },
          threshold: null
        }
      },
      series: [{
        type: 'area',
        name: 'Temperature',
        data: this.dataFormatter(this.props.data)
      }]
    };

    return (
      <div>
        <HighchartsReact highcharts={Highcharts} options={config} />
        <Grid container style={{ marginLeft: this.props.margin }}>
          <Grid item xs={10} className="font-style">
            {this.props.convertTimeZone(this.props.startDate)}
          </Grid>
          <Grid item xs={2} className="font-style">
          {this.props.convertTimeZone(this.props.endDate)}
          </Grid>
        </Grid>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/temparature_monitoring/Dashboard.js